import React, { useState } from "react";
import { Box, Typography, Divider, Select, MenuItem, TextField } from "@mui/material";
import BaseButton from "../UI/BaseButton/BaseButton";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import BaseCard from "../UI/BaseCard/BaseCard";

function CardDetailsModal({
  open,
  handleClose,
  cardOption,
  handleCardOption,
  cardDetails,
  submitCardOption,
}) {
  const [alert, setAlert] = useState({
    severity: "",
    show: false,
    message: "",
    header: "",
  });

  const [alertNew, setAlertNew] = useState({
    showAlert: false,
    severity: "",
    header: "",
    message: "",
    onConfirm: null,
    alertType: ''
  });

  let isAdmin = sessionStorage.getItem("isAdmin");

  console.log("cardDetails---------",cardDetails);
  console.log("cardOption---------",cardOption);

  const statusMap = {
    "-1": "Blocked",
    "1": "Deleted",
    "2": "Assigned - Not Active",
    "3": "Lost",
    "4": "Damaged",
  };

  const MCstatusMap = {
    "14": "Blocked",
    "4": "Active",
    "-1": "Pending for Approval",
    "0" : "Active",
    "1": "Cancelled",
    // "1": "Deleted from Wallet",
    "2": "Blocked",
  };


  function getCardType(cardNumber) {
    if (cardNumber.startsWith('4')) {
      return 'Rêve Plata Card';
    } else if (cardNumber.startsWith('5')) {
      return 'Rêve Mastercard';
    } else {
      return 'Unknown Card Type';
    }
  }

  const handleCancelCard = async() => {
    const response = await submitCardOption();
      if (response.callStatus === "1" || response.callStatus === "2") {
        setAlert({
          severity: "success",
          show: true,
          header: "Success",
          message: "Card updated successfully",
        })
      }
      else {
        setAlert({
          severity: "error",
          show: true,
          header: "Error",
          message: "Failed to update card",
        })
      }
  }

  return (
    <BaseDrawer
      open={open}
      handleClose={handleClose}
      height="80vh"
      title="Card Details"
    >
      <BaseCard>
        <Box sx={{ padding: "20px" }}>

          {/* Card Details Section */}
          <Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                label="Card Number"
                value={isAdmin === 'true' ? cardDetails?.cardnumber : cardDetails?.hiddencardnumber}
                disabled
                variant="standard"
                sx={{
                  width: "50%",
                }}
              />
            </Box>

            <Box sx={{ mb: 2 }}>
              <TextField
                label="Card Type"
                // value="Physical Card"
                value={getCardType(cardDetails?.cardnumber)}
                disabled
                variant="standard"
                sx={{
                  width: "50%"
                }}
              />
            </Box>

            {cardDetails?.assignedon && <Box sx={{ mb: 2 }}>
              <TextField
                label="Assigned Date"
                value={cardDetails?.assignedon}
                disabled
                variant="standard"
                sx={{
                  width: "50%",
                }}
              />
            </Box>}

            <Box sx={{ mb: 2 }}>
              <TextField
                label="Card Status"
                value={
                  cardDetails.type === "Plata Card" 
                  ?
                    cardDetails?.active === 1 || cardDetails?.active === "1" ? "Assigned" : statusMap[cardDetails?.status]
                  :
                  MCstatusMap[cardDetails?.status] || cardDetails?.status
                }
                disabled
                variant="standard"
                sx={{
                  width: "50%"
                }}
              />
            </Box>

            <Box sx={{ mb: 2 }}>
              <TextField
                label="Activity"
                value={
                  cardDetails?.type === "Plata Card" 
                  ?
                  cardDetails?.active === 1 || cardDetails?.active === "1" ? "Active" : "Inactive"
                  :
                  cardDetails?.active === 0 || cardDetails?.active === "0" ? "Active" : "Inactive"
                }
                disabled
                variant="standard"
                sx={{
                  width: "50%",
                }}
              />
            </Box>
          </Box>

          <Divider sx={{ my: 2, border: "1px solid #A6A6A6" }} />

          {cardDetails?.type === "Plata Card" && <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Update Card Status
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <Select
                name="card-options"
                id="card-program-years"
                value={cardOption || "na"}
                onChange={handleCardOption}
                disabled={cardDetails?.status === "3" || cardDetails?.status === "4" ? true : false}
                defaultValue="na"
                sx={{
                  border: "1px solid #D7D7D7",
                  height: "35px",
                  borderRadius: "5px",
                  minWidth: "200px",
                }}
              >
                <MenuItem value="na">Select an option</MenuItem>
                <MenuItem value="lost">Lost</MenuItem>
                <MenuItem value="damaged">Damaged</MenuItem>
              </Select>
              <Box
                sx={{
                  marginBottom: "15px"
                }}
              >
                <BaseButton
                  buttonText={"Update"}
                  disabled={cardDetails?.status === "3" || cardDetails?.status === "4" ? true : false}
                  onClick={async () => { 
                    const response = await submitCardOption();
                    if (response.callStatus === "1") {
                      setAlert({
                        severity: "success",
                        show: true,
                        header: "Success",
                        message: "Card status updated successfully and also removed from card approval table.",
                      })
                    }
                    else {
                      setAlert({
                        severity: "error",
                        show: true,
                        header: "Error",
                        message: "Failed to update card",
                      })
                    }
                  }}
                  className={"update-button"}
                />
              </Box>
            </Box>
            <span>*Once the card status is updated to lost or damaged, it cannot be reverted back.</span>
          </Box>}

          {cardDetails?.type === "Mastercard" && isAdmin === 'true' && cardDetails?.status !== "1" && <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Update Card Status
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <Select
                name="card-options"
                id="card-program-years"
                value={cardOption || "na"}
                defaultValue={"na"}
                onChange={handleCardOption}
                disabled={cardDetails?.status === "14" ? true : false}
                sx={{
                  border: "1px solid #D7D7D7",
                  height: "35px",
                  borderRadius: "5px",
                  minWidth: "200px",
                }}
              >
                <MenuItem value="na">Select an option</MenuItem>
                {cardDetails?.active !== "2" && <MenuItem value="block">Block (Temporary)</MenuItem>}
                {cardDetails?.active == "2" && <MenuItem value="unblock">Unblock</MenuItem>}
                <MenuItem value="cancel">Cancel (Permanent)</MenuItem>
              </Select>
              <Box
                sx={{
                  marginBottom: "15px"
                }}
              >
                <BaseButton
                  buttonText={"Update"}
                  disabled={cardDetails?.status === "14" ? true : false}
                  onClick={async () => { 
                    if(cardOption == "cancel") {
                      setAlertNew({
                        ...alertNew,
                        showAlert: true,
                        message: "Once cancelled, this card cannot be reactivated. Are you sure you want to cancel it?",
                        severity: "confirm",
                        header: "Please Confirm",
                        alertType: 'confirm',
                        onConfirm: () => handleCancelCard()
                      })
                    } else {
                      const response = await submitCardOption();
                      if (response.callStatus === "1" || response.callStatus === "2") {
                        setAlert({
                          severity: "success",
                          show: true,
                          header: "Success",
                          message: "Card updated successfully",
                        })
                      }
                      else {
                        setAlert({
                          severity: "error",
                          show: true,
                          header: "Error",
                          message: "Failed to update card",
                        })
                      }
                    }
                  }}
                  className={"update-button"}
                />
              </Box>
            </Box>
          </Box>}

          <CustomAlert
            severity={alertNew.severity}
            show={alertNew.showAlert}
            header={alertNew.header}
            message={alertNew.message}
            onClick={() => {
                setAlertNew({ ...alertNew, showAlert: false });
            }}
            alertType={alertNew.alertType}
            confirmButton={alertNew.onConfirm}
            autoclose={alertNew.severity === "error" ? false : true}
            confirmButtonText={"Yes"}
            cancelButtonText={"No"}
          />

          <CustomAlert
            severity={alert.severity}
            show={alert.show}
            header={alert.header}
            message={alert.message}
            onClick={() => {
              setAlert((prevDetails) => ({ ...prevDetails, showAlert: false }));
              if (alert.severity === "success") {
                handleClose();
                setAlert({
                  ...alert,
                  show: false,
                });
              }
              else {
                setAlert({
                  ...alert,
                  show: false,
                });
              }
            }}
            autoclose={alert.severity === "error" ? false : true}
          />
        </Box>

      </BaseCard>
    </BaseDrawer>
  );
}

export default CardDetailsModal;
